import { render, staticRenderFns } from "./ApiaryCardMinimalistComponent.vue?vue&type=template&id=26cb825c&"
import script from "./ApiaryCardMinimalistComponent.vue?vue&type=script&lang=js&"
export * from "./ApiaryCardMinimalistComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports